import axios from "axios";
import * as constants from "@/config/constants";

let config;

export default {
    init: async () => {
        config = (await axios.get(constants.WEB_UI_ROOT + "/config.json?t=" + Date.now())).data;
    },
    switchToNextFallbackPgwyBaseUrl: () => {
        if (!Array.isArray(config.pgwyBaseUrl) || config.pgwyBaseUrl.length < 2) {
            return false;
        }
        config.pgwyBaseUrl.splice(0, 1);
        return true;
    },
    getPGWYBaseUrl: () => {
        return Array.isArray(config.pgwyBaseUrl) ? config.pgwyBaseUrl[0] : config.pgwyBaseUrl;
    },
}